<div class="control-card-content">

  <div *ngIf="userCanExecutionEdit"  class="buttons-container">

    <ng-container id="addPeriodicExecution">
      <a (click)="addExecution()" class="button">
        <ng-container i18n="@@periodic_execution_add_periodic_execution">Aggiungi automatismo periodico
        </ng-container> <span>
          <fa-icon icon="clock"></fa-icon>
        </span>
      </a>
    </ng-container>
  </div>

  <div class="table-filter">
    <p i18n="@@periodic_executions_filter">Filtra: </p>
    <input id="filter-input" (keyup)="onKey($event)" />
  </div>


  <table mat-table matSort #periodicExecutionstable class="simple-table">

    <ng-container matColumnDef="serial">
      <th mat-header-cell mat-sort-header *matHeaderCellDef i18n="@@periodic_executions_serial" style="width: 10%;">
        Seriale
      </th>
      <td mat-cell *matCellDef="let element"> {{ element.serial }} </td>
    </ng-container>

    <ng-container matColumnDef="description">
      <th mat-header-cell mat-sort-header *matHeaderCellDef i18n="@@periodic_executions_description"
        style="width: 30%;">Descrizione
      </th>
      <td mat-cell *matCellDef="let element"> {{ element.description }} </td>
    </ng-container>

    <ng-container matColumnDef="daysAllowed">
      <th mat-header-cell mat-sort-header *matHeaderCellDef i18n="@@periodic_executions_days_allowed"
        style="width: 20%;">Giorni settimanali
      </th>
      <td mat-cell *matCellDef="let element"> {{ element.daysAllowed }} </td>
    </ng-container>

    <ng-container matColumnDef="hoursAllowed">
      <th mat-header-cell mat-sort-header *matHeaderCellDef i18n="@@periodic_executions_hours_allowed"
        style="width: 20%;">Fasce orarie
      </th>
      <td mat-cell *matCellDef="let element"> {{ element.hoursAllowed }} </td>
    </ng-container>

    <ng-container matColumnDef="result">
      <th mat-header-cell mat-sort-header *matHeaderCellDef i18n="@@periodic_executions_result" style="width: 15%;">
        Stato
      </th>
      <td mat-cell *matCellDef="let element"> {{ element.result }} </td>
    </ng-container>

    <ng-container matColumnDef="deleteExecution">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element">
        <fa-icon  *ngIf="userCanExecutionEdit"  icon="trash" class="float-right padding-5 icon-clickable" (click)="deleteExecution(element)">
        </fa-icon>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumnsPeriodic"></tr>

    <tr mat-row *matRowDef="let row; columns: displayedColumnsPeriodic;"></tr>

  </table>

</div>

<app-loading-screen #periodicExecutionsloader [loading]="false"></app-loading-screen>
